import React, { useState, useRef } from 'react'
import moment from 'moment'

const formatLocation = (name, city, state) => {
    const parts = [city, state].filter(Boolean).join(', ')
    return name ? (parts ? `${name} — ${parts}` : name) : parts
}

const ExpiredCarrierView = ({ shipment, isConsolidation, reason }) => {
    const [copied, setCopied] = useState(false)
    const alertRef = useRef(null)

    const copyBoxContents = () => {
        const text = alertRef.current?.innerText || ''
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        })
    }
    const shipmentId = shipment?.id || shipment?.usercontrol || null
    const deliveryDate = shipment?.consignee?.dates?.available2
        || shipment?.consignee?.dates?.requestedDeliveryDate
        || null

    const stops = shipment?.stops || []

    const origin = formatLocation(
        shipment?.shipper?.name,
        shipment?.shipper?.address?.city,
        shipment?.shipper?.address?.state
    )
    const destination = formatLocation(
        shipment?.consignee?.name,
        shipment?.consignee?.address?.city,
        shipment?.consignee?.address?.state
    )

    return (
        <div className="container">
            <div className="row justify-content-center mt-5">
                <div className="col-12 col-md-6 text-center">
                    <div className="mb-4">
                        <img
                            src="https://scheduler.shippersedge.com/shippersedge-logo.png"
                            alt="ShippersEdge"
                            style={{ maxWidth: '300px' }}
                            className="img-fluid"
                        />
                        <span className="TitleText mt-2 d-block">Dock Scheduler</span>
                    </div>
                    <div className="alert alert-secondary text-start" role="alert" ref={alertRef}>
                        <div className="d-flex justify-content-between align-items-start mb-1">
                            <h4 className="alert-heading mb-0 flex-grow-1 text-center">Scheduling Link Not Active</h4>
                            <button
                                className="btn btn-sm btn-outline-secondary py-0 px-1 ms-2 flex-shrink-0"
                                style={{ fontSize: '0.7rem', lineHeight: '1.4' }}
                                onClick={copyBoxContents}
                                title="Copy all details"
                            >
                                {copied ? '✓ Copied' : 'Copy'}
                            </button>
                        </div>
                        <p className="text-center mb-0">
                            This shipment is not currently allowing carrier appointments.
                        </p>
                        <hr />
                        {shipmentId && (
                            <p className="mb-1">
                                <strong>Shipment:</strong> {shipmentId}
                            </p>
                        )}
                        {shipment?.usercontrol && (
                            <p className="mb-1">
                                <strong>Reference:</strong> {shipment.usercontrol}
                            </p>
                        )}
                        {shipment?.client?.name && (
                            <p className="mb-1">
                                <strong>Client:</strong> {shipment.client.name}
                            </p>
                        )}
                        {shipment?.carrier?.name && (
                            <p className="mb-1">
                                <strong>Carrier:</strong> {shipment.carrier.name}
                            </p>
                        )}
                        {!isConsolidation && deliveryDate && (
                            <p className="mb-2">
                                <strong>Delivery Date:</strong> {moment(deliveryDate).format('MMM D, YYYY')}
                            </p>
                        )}
                        {isConsolidation && stops.length > 0 ? (
                            <div className="mt-2">
                                {stops.map((stop, i) => {
                                    const isPickup = stop.type === 'Pickup'
                                    const stopDate = isPickup
                                        ? (stop?.dates?.available2 || stop?.dates?.available1)
                                        : (stop?.dates?.requestedDeliveryDate || stop?.dates?.available2 || stop?.dates?.available1)
                                    return (
                                        <div key={i} className="border rounded px-3 py-2 mb-2">
                                            <div>
                                                <strong>Stop {stop.stopNumber} ({stop.type})</strong>
                                            </div>
                                            <div className="text-muted small">
                                                {formatLocation(stop.name, stop.address?.city, stop.address?.state)}
                                            </div>
                                            {stopDate && (
                                                <div className="small mt-1">
                                                    {isPickup ? 'Pickup:' : 'Delivery:'} {moment(stopDate).format('MMM D, YYYY')}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <>
                                {origin && (
                                    <p className="mb-1">
                                        <strong>Pickup:</strong> {origin}
                                    </p>
                                )}
                                {destination && (
                                    <p className="mb-1">
                                        <strong>Delivery:</strong> {destination}
                                    </p>
                                )}
                            </>
                        )}
                        <p className="mt-3 mb-0 text-muted small text-center">
                            If you have questions about this shipment, please contact the shipper directly.
                        </p>
                        {reason && (
                            <p className="mt-2 mb-0 text-muted text-center" style={{ fontSize: '0.65rem' }}>
                                Reason: {reason}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExpiredCarrierView
